// extracted by mini-css-extract-plugin
export default {"day":"Day_day__pll6H","weekday":"Day_weekday__MHERU","date":"Day_date__VytrO","today":"Day_today__fq2jQ","box":"Day_box__oS+hf","boxArrange":"Day_boxArrange__UP-xx"};